import * as React from 'react';
import DownloadIcon from '@mui/icons-material/Download';
import { useMutation } from '@tanstack/react-query';
import { getScreenshotUrl, SmartScreenshotResponse } from 'services/clients/perDiem';
import { Button } from '@mui/material';
import { useSegment } from 'common/hooks/segment';
import { SmartRow } from '../../types';

interface Props {
  row: SmartRow;
  onModal: (code: SmartScreenshotResponse['code']) => void;
  variant?: 'minimal';
}

export const Screenshots: React.FC<Props> = (props) => {
  const { row, onModal, variant } = props;
  const { track } = useSegment();

  const { id } = row;
  const getScreenshotMutation = useMutation(getScreenshotUrl);

  switch (row.type) {
    case 'placeholder':
    case 'no-data':
    case 'alert':
      return null;
    default:
      break;
  }

  const handleClick: React.MouseEventHandler<HTMLButtonElement> = (e) => {
    e.stopPropagation();

    getScreenshotMutation.mutate(
      { emptyReturnAvailabilityId: id },
      {
        onSuccess: (response) => {
          switch (response.code) {
            case 'ok':
              window.open(response.url, '_blank');
              track(
                'User downloaded individual screenshot',
                {
                  origin: 'per-diem-fighter',
                  success: true,
                  error: '',
                },
                { includeUser: true }
              );
              break;
            case 'no_credits':
            case 'no_screenshot':
            case 'error':
              onModal(response.code);
              track(
                'User downloaded individual screenshot',
                {
                  origin: 'per-diem-fighter',
                  success: false,
                  error: response.code,
                },
                { includeUser: true }
              );
              break;
            default:
              break;
          }
        },
        onError: (error) => {
          // eslint-disable-next-line no-console
          console.error(error);
          onModal('error');
          track(
            'User downloaded individual screenshot',
            {
              origin: 'per-diem-fighter',
              success: false,
              // eslint-disable-next-line
              // @ts-ignore
              error: error.message,
            },
            { includeUser: true }
          );
        },
      }
    );
  };

  return (
    <Button
      onClick={handleClick}
      className="text-blue-900 flex space-x-4 items-center p-0"
      variant="text"
      style={{ minWidth: 0 }}
    >
      {variant && variant === 'minimal' ? null : <span className="underline">View screenshot</span>}
      <div className="rounded-full border border-blue-900 w-6 h-6 text-center bg-blue-200 p-0 shrink-0 flex items-center justify-center">
        <DownloadIcon style={{ fontSize: 14 }} />
      </div>
    </Button>
  );
};
Screenshots.displayName = 'SmartPerDiem.Table.Cell.Screenshots';
